import axios from 'axios'
export const get_suffix = (filename) => {
  var pos = filename.lastIndexOf('.')
  var suffix = ''
  if (pos != -1) {
    suffix = filename.substring(pos)
  }
  return suffix
}

export const random_string = (len) => {
  len = len || 32
  var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
  var maxPos = chars.length
  var pwd = ''
  for (var i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos))
  }
  return pwd
}



export const uploadImg = (file, fileSize) => {
  if(file){
    return new Promise(function(resolve, reject) {
      //1。 请求服务端获取上传地址 POST JSON
      let postData = {
        content_type:file.type ? file.type : '*/*',
        file_name:file.name
      }
      axios.post('https://uploads.enlightv.com/get_upload_url', postData).then(res => {
        if(res.data.upload_url){
          axios.put(res.data.upload_url, file, {
            headers: {
              "Content-Type": file.type ? file.type : '*/*',
              'x-oss-storage-class': 'Standard',
            }
          })
              .then(function(response) {
                // 处理成功
                let returnData={
                  file_path:res.data.url,
                  file_name:file.name,
                  file_type:file.type
                }
                resolve(returnData)
              })
              .catch(function(error) {
                // 处理错误
              });
        }
      }).catch(err => {
        if (!err.response) {

        } else {
          reject(err.data)
        }
      })
    })
  } else {
    return new Promise(function (resolve, reject) {
      reject()
    })
  }
}


export const getOSSData = (filePath, fileName) => {
  window.location.href = `${filePath}?response-content-disposition=attachment%3B%20filename%3D${fileName}`
}
